export default __webpack_public_path__ + "static/media/scan-collect.6879aa02.png";